import React from 'react';
import './Hero.css'
import { Button } from 'react-bootstrap';



const Hero = () => {
    return (
        <div className="txbg" >
            <h1 className="herotext mt-3">Hi. I am <span className="name ">Nahar</span></h1>
            <p className="text pt-3 ">Web Developer+ Digital Nomad + Designer <br />
                I have a serious passion for UI effects, animations, and creating intuitive, dynamic user experiences.</p>
            <Button className="px-5 py-3 rounded-pill my-4 glow-on-hover ty-5" href="https://drive.google.com/file/d/1haDkxkzEKeLMa65ftU3HmQVwgXRDNTGM/view?usp=sharing" target="_blank">Download Resume</Button>
            <hr className=" text-white w-75 mt-5 ms-auto" />
        </div>
    );
};

export default Hero;